import { render } from "./assessment.vue?vue&type=template&id=328fd7de&ts=true"
import script from "./assessment.vue?vue&type=script&lang=ts"
export * from "./assessment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__